// extracted by mini-css-extract-plugin
export var actions = "_tp-4";
export var item = "_tp-1";
export var price = "_tp-3";
export var quantity = "_tp-2";
export var table = "_tp-0";